/*
 * decaffeinate suggestions:
 * DS001: Remove Babel/TypeScript constructor workaround
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
module.exports.ServerGralError = class ServerGralError extends Error {
  constructor(message) {
    super(message);
    this.name = 'ServerGralError';
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, ServerGralError);
    }
  }
};

module.exports.ServerInvalidError = class ServerInvalidError extends Error {
  constructor(messages = {}) {
    const message = Object.keys(messages)
      .map(attr => `${attr}: ${messages[attr]}`)
      .join(' | ');
    if (message) {
      super(message);
      this.name = 'ServerInvalidError';
      if (typeof Error.captureStackTrace === 'function') {
        Error.captureStackTrace(this, ServerInvalidError);
      }
      this.messages = messages;
    }
  }
};
